// extracted by mini-css-extract-plugin
module.exports = {"toggleBtn":"CustomWorkout_toggleBtn__f0k7d","saveButton":"CustomWorkout_saveButton__2C6Uu","cancelBtn":"CustomWorkout_cancelBtn__2KNar","scoring":"CustomWorkout_scoring__dWGG7"};